var millisecondsInMinute = 6e4;
var millisecondsInHour = 36e5;
export {
  millisecondsInHour,
  millisecondsInMinute
};
